import { Component, type ReactNode } from 'react';

/**
 * Vangt crashes in een scherm op, zodat je een melding ziet in plaats van een zwarte pagina.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('[tumedia] scherm gecrasht', error);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <main className="center-screen" role="alert">
        <h1 style={{ fontSize: 'calc(var(--u) * 2.6)' }}>Er ging iets mis</h1>
        <p className="lead muted">Dit scherm liep vast. Stuur de regel hieronder door als het blijft gebeuren.</p>
        <pre className="subtle" style={{ whiteSpace: 'pre-wrap', maxWidth: '70ch', fontSize: 13 }}>{error.message}</pre>
        <div style={{ display: 'flex', gap: 12 }}>
          <button className="btn btn-primary" data-autofocus onClick={() => { this.setState({ error: null }); history.back(); }}>Terug</button>
          <button className="btn" onClick={() => location.reload()}>Pagina herladen</button>
        </div>
      </main>
    );
  }
}
